import React from 'react';
import Logo from "../images/logo.svg";

const Header = () => {
  
  return (
      <>
        <div id='header'>
          <div className='logo'>
            <div className='logo_icon'>
              <img src={Logo} />
            </div>
            <div className='brand_name'>Charts Reports</div>
          </div>

          {/* <div className='header_monthly_value'>
            <div className='month_price_row'>
              <div className='month_col'>
              36<span>-month</span>
              </div>
              <div className='price_white_col'>
               9,000,000,000,000,000.00 <span>USD</span>
              </div>
            </div>

            <div className='month_price_row'>
              <div className='month_col'>
              24<span>-month</span>
              </div>
              <div className='price_byellow_col'>
                9,000,000,000,000,000.00 <span>USD</span>
              </div>
            </div>
          </div> */}
       </div>
      </>
  );
};

export default Header;
